import { SectionsProps } from '../../types/types';
import { connectionTexts } from '../../data/data';
import Button from '../Button/Button';
import SocialMedia from './SocialMedia/SocialMedia';

const Connection = ({ openModal, openIsModal }: SectionsProps) => {
  return (
    <section className='connection'>
      <div className='connection__container grid-fons'>
        <div className='connection__wrap'>
          <div className='connection__info'>
            <h1 className='connection__title title'>Contact Us</h1>
            <p className='connection__text subtitle'>Let’s work together!</p>
          </div>
          <div className='connection__inner'>
            {connectionTexts.map((item) => (
              <p key={item.id} className='connection__text text-large'>
                {item.text}
              </p>
            ))}
          </div>
          <div className='connection__buttons'>
            <Button
              className='connection__button'
              type='button'
              onClick={openModal}
            >
              Sales
            </Button>
            <Button
              className='connection__button'
              variant='secondary'
              type='button'
              onClick={() => {
                window.location.href = 'https://docs.contactpay.com/?lang=en';
              }}
            >
              Read docs
            </Button>
            {/* <Button
              className='connection__button'
              onClick={openIsModal}
              variant='secondary'
              type='button'
            >
              Support
            </Button> */}
          </div>
        </div>
        <SocialMedia className='media' />
      </div>
    </section>
  );
};
export default Connection;
